const burgerMenuBtn = document.querySelector('.hamburger-menu');

const burgerMenu = document.querySelector('.header-popup');
const headerCategoriesListBtns = document.querySelector('.header-categories').querySelectorAll('.header-categories__mainItem-btn');

burgerMenuBtn.addEventListener('click', () => {
  burgerMenuBtn.classList.toggle('hamburger-menu_active');
  burgerMenu.classList.toggle('header-popup_active');
  document.body.classList.toggle('body-lock');
});

// Toggle header categories
headerCategoriesListBtns.forEach((el) => {
  el.addEventListener('click', () => {
    const headerCategoriesList = el.parentElement.parentElement;
    const submenu = headerCategoriesList.querySelector('.header-categories__submenu');
    console.log(submenu);
    if (headerCategoriesList.classList.contains('header-categories__item_active')) {
      // Collapse
      submenu.style.height = '0';
    } else {
      // Expand
      submenu.style.height = 'auto';
      const height = submenu.scrollHeight;
      submenu.style.height = '0';
      // Force a reflow
      submenu.offsetHeight;
      submenu.style.height = `${height}px`;
    }

    headerCategoriesList.classList.toggle('header-categories__item_active');
  });
})

const searchInputs = document.querySelectorAll('.search input');

searchInputs.forEach(input => {
  input.addEventListener('focus', () => {
    input.closest('.search').classList.add('search_focused');
    input.classList.add('search__input_focused');
  });

  input.addEventListener('blur', () => {
    input.closest('.search').classList.remove('search_focused');
    input.classList.remove('search__input_focused');
  });
});